(function () {
  "use strict";

  angular
    .module("admin.users.details.messages", [
      "admin.users.details.messages.details",
    ])
    .controller("MessagesAdminCtrl", MessagesAdminCtrl);

  /** @ngInject */
  function MessagesAdminCtrl($scope, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.usernameChat = "";
    vm.usernameTrade = "";
    vm.usersPerPage = 25;

    vm.sortType = "";
    vm.sortReverse = false;

    //trade
    vm.totalUsers = 0;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1,
    };

    //chat
    vm.totalUsers2 = 0;
    vm.oldPage2 = 0;
    vm.currentPage2 = 25;
    vm.first2 = true;
    vm.totalItems2 = 0;
    vm.pagination2 = {
      current: 1,
    };

    loadTrade(1);
    loadChat(1);

    var oldSortType;
    function loadTrade(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      UsersService.listTradeMessages(
        $stateParams.parentId,
        vm.oldPage,
        25,
        vm.sortType,
        vm.usernameTrade
      ).then(success);

      function success(result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        var users = [];
        for (var i = 0; i < result.results.length; i++) {
          if (parseInt(vm.userId) === result.results[i].t.ua.id) {
            if (result.results[i].t.ub !== undefined) {
              result.results[i].t.ub.id2 = result.results[i].id;
              if (result.results[i].t && result.results[i].t.ua["ts-m"]) {
                result.results[i].t.ub["ts-m2"] =
                  result.results[i].t.ua["ts-m"];
              }
              if (result.results[i].t && result.results[i].t["ts-m"]) {
                result.results[i].t.ub["ts-update"] =
                  result.results[i].t["ts-m"];
              }
              users.push(result.results[i].t.ub);
            }
          } else {
            if (result.results[i].t.ua !== undefined) {
              result.results[i].t.ua.id2 = result.results[i].id;
              result.results[i].t.ua["ts-m2"] = result.results[i].t.ub["ts-m"];
              result.results[i].t.ua["ts-update"] = result.results[i].t["ts-m"];
              users.push(result.results[i].t.ua);
            }
          }
        }

        for (var i = 0; i < users.length; i++) {
          if (users[i]["ts-m"] !== undefined) {
            users[i]["ts-m"] = new Date(
              parseInt(
                users[i]["ts-m"]
                  .toString()
                  .substring(0, users[i]["ts-m"].toString().length - 3)
              )
            );
          }
          if (users[i]["ts-m2"] !== undefined) {
            users[i]["ts-m2"] = new Date(
              parseInt(
                users[i]["ts-m2"]
                  .toString()
                  .substring(0, users[i]["ts-m2"].toString().length - 3)
              )
            );
          }
          if (users[i]["ts-update"] !== undefined) {
            users[i]["ts-update"] = new Date(
              parseInt(
                users[i]["ts-update"]
                  .toString()
                  .substring(0, users[i]["ts-update"].toString().length - 3)
              )
            );
          }
        }

        vm.sortType = oldSortType;
        vm.itemsTrade = _.orderBy(users, ["ts-update"], ["desc"]);
      }
    }

    function loadChat(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination2.current = 1;
      }
      if (!vm.first2) {
        vm.currentPage2 = pageNumber * 25;
        vm.oldPage2 = vm.currentPage2 - 25;
      } else {
        vm.first2 = false;
      }
      UsersService.listChatMessages(
        $stateParams.parentId,
        vm.oldPage2,
        25,
        vm.sortType,
        vm.usernameChat
      ).then(success);

      function success(result) {
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct;
        }
        var users = [];
        for (var i = 0; i < result.results.length; i++) {
          if (parseInt(vm.userId) === result.results[i].u[0].id) {
            result.results[i].u[1].id2 = result.results[i].id;
            if (result.results[i].u[0]["ts-m"]) {
              result.results[i].u[1]["ts-m2"] = result.results[i].u[0]["ts-m"];
            }
            if (
              result.results[i].m &&
              result.results[i].m["ts-m"] &&
              result.results[i].u.length > 1
            ) {
              result.results[i].u[1]["real-date"] = result.results[i].m["ts-m"];
            }
            users.push(result.results[i].u[1]);
          } else {
            result.results[i].u[0].id2 = result.results[i].id;
            result.results[i].u[0]["ts-m2"] = result.results[i].u[1]["ts-m"];
            if (result.results[i].m && result.results[i].m["ts-m"]) {
              result.results[i].u[0]["real-date"] = result.results[i].m["ts-m"];
            }
            users.push(result.results[i].u[0]);
          }
        }

        for (var i = 0; i < users.length; i++) {
          if (users[i]["ts-m"] !== undefined) {
            users[i]["ts-m"] = new Date(
              parseInt(
                users[i]["ts-m"]
                  .toString()
                  .substring(0, users[i]["ts-m"].toString().length - 3)
              )
            );
          }
          if (users[i]["ts-m2"] !== undefined) {
            users[i]["ts-m2"] = new Date(
              parseInt(
                users[i]["ts-m2"]
                  .toString()
                  .substring(0, users[i]["ts-m2"].toString().length - 3)
              )
            );
          }
          if (users[i]["real-date"] !== undefined) {
            users[i]["real-date"] = new Date(
              parseInt(
                users[i]["real-date"]
                  .toString()
                  .substring(0, users[i]["real-date"].toString().length - 3)
              )
            );
          }
        }

        vm.itemsChat = _.orderBy(users, ["real-date"], ["desc"]);
      }
    }

    var tab = localStorage.getItem("tabchat");
    if (tab !== null) {
      if (tab === "trade") {
        $("#chat").removeClass("active");
        $("#trade").addClass("active");
        $("#tradetab").addClass("active");
      } else {
        $("#trade").removeClass("active");
        $("#chat").addClass("active");
        $("#chattab").addClass("active");
      }
    } else {
      $("#trade").addClass("active");
      $("#tradetab").addClass("active");
    }

    vm.tabTrade = function () {
      $("#chat").removeClass("active");
      $("#trade").addClass("active");
      localStorage.setItem("tabchat", "trade");
    };

    vm.tabChat = function () {
      $("#trade").removeClass("active");
      $("#chat").addClass("active");
      localStorage.setItem("tabchat", "chat");
    };

    vm.pageChangedChat = function (newPage) {
      loadChat(newPage);
    };

    vm.pageChangedTrade = function (newPage) {
      vm.sortType = oldSortType;
      loadTrade(newPage);
    };

    vm.sort = function (type, isTab) {
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + "-asc";
      } else {
        vm.sortType = type + "-desc";
      }

      if (isTab === 1) {
        loadTrade(vm.pagination.current);
      } else {
        loadChat(vm.pagination2.current);
      }
    };

    vm.searchTrade = function () {
      if (vm.searchTrade === undefined || vm.searchTrade === null) {
        return;
      }

      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.sortType = oldSortType;
      loadTrade(1);
    };

    vm.searchChat = function () {
      if (vm.searchChat === undefined || vm.searchChat === null) {
        return;
      }

      vm.totalUsers2 = 0;
      vm.oldPage2 = 0;
      vm.currentPage2 = 25;
      vm.first2 = true;
      vm.totalItems2 = 0;
      loadChat(1);
    };
  }
})();
